module.exports = __webpack_public_path__ + "img/offers-active.f6309c46.svg";